<template>
  <b-row class="my-3">
    <b-col lg="7" md="9" class="mx-auto">
      <b-form-group
        label="Verify Account"
        class="mb-2"
        label-class="head-label"
      >
          <p>Please enter the OTP to validate your account.</p>
          <b-form-input
            v-model="form.pin"
            :state="isInvalid('pin')"
            @keypress.native="filterNumeric"
            @keyup.native="trimNumber('pin')"
            maxlength="4"
            pattern="[0-9]*"
            inputmode="numeric">
          </b-form-input>
          <b-form-invalid-feedback :state="isInvalid('pin')">
            {{ errorMessage("pin") }}
          </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <b-form-input type="text" hidden :state="isInvalid('message')"></b-form-input>
        <b-form-invalid-feedback :state="isInvalid('message')">
          {{ errorMessage("message") }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group class="mb-2">
        <b-button
          class="p-0 bg-transparent text-primary border-0 shadow-none"
          :disabled="isLoading"
          @click="resendOtp('mobile')">
          Resend OTP
        </b-button>
      </b-form-group>
      <b-form-group>
        <b-button
          class="p-0 bg-transparent text-primary border-0 shadow-none"
          :disabled="isLoading"
          @click="resendOtp('email')">
          Send OTP via Email
        </b-button>
      </b-form-group>
      <b-form-group>
        <b-button
          variant="primary"
          class="text-white mx-auto"
          pill
          block
          :disabled="isLoading"
          @click="validateField">
          Proceed
        </b-button>
      </b-form-group>
      <b-form-group>
        <router-link
          :to="{ name: 'Login' }"
          class="text-muted">
          Back to Login
        </router-link>
      </b-form-group>
    </b-col>
    <ResendOtpViaEmail />
  </b-row>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import notification from "@/services/notification";
import ResendOtpViaEmail from "@/components/ResendOtpViaEmail";

function initForm() {
  return {
    pin: null
  }
}

export default {
  name: "ForgotPin",
  components: {
    ResendOtpViaEmail
  },
  data() {
    return {
      form: initForm(),
      otp_channel: null
    }
  },
  computed: {
    ...mapGetters("auth", ["isLoading", "errors", "customerMobile", "customerEmail"])
  },
  beforeDestroy() {
    this.setErrors(null);
  },
  methods: {
    ...mapMutations("auth", ["setErrors"]),
    ...mapActions("auth", ["verifyOtp", "sendOtp"]),
    isNotNumeric(input) {
      return /[^0-9]/g.test(input);
    },
    filterNumeric(e) {
      if (this.isNotNumeric(String.fromCharCode(e.keyCode))) e.preventDefault();
    },
    isInvalid(field) {
      if (this.errors === null) {
        return null;
      } else {
        return !Object.keys(this.errors).includes(field)
          ? null
          : !Object.keys(this.errors).includes(field);
      }
    },
    errorMessage(field) {
      if (this.errors === null) {
        return "";
      } else if (Object.keys(this.errors).includes(field)) {
        return Array.isArray(this.errors[field])
          ? this.errors[field].join(" ")
          : this.errors[field];
      }
    },
    validateField() {
      const errors = {};

      if (!this.form.pin) errors["pin"] = "PIN is required";
      else if (this.form.pin && this.isNotNumeric(this.form.pin)) errors["pin"] = "Only numeric characters are allowed";

      this.setErrors(errors);

      if (Object.keys(errors).length === 0) this.submitForm();
      else notification.warning("Oops, something went wrong.");
    },
    async submitForm() {
      const payload = {
        origin: this.otp_channel ? this.otp_channel : "mobile",
        pin: this.form.pin
      };

      if (this.otp_channel && this.otp_channel === "email") {
        payload["email"] = this.customerEmail
      } else if (!this.otp_channel || this.otp_channel === "mobile") {
        payload["mobile_number"] = this.customerMobile
      }

      await this.verifyOtp(payload)
        .then(() => {
          if (this.errors === null || Object.keys(this.errors).length === 0) {
            this.$router.push({ name: "ResetMpin" });
          }
        });
    },
    resendOtp(via) {
      this.otp_channel = via;
      if (via === "mobile")
        this.sendOtp({
          mobile_number: this.customerMobile,
          action: "FORGOT_PIN_MOBILE"
        });
      else
        this.$root.$emit("bv::show::modal", "resend-otp-via-email");
    },
    trimNumber: function(ref) {
      if (this.form[ref])
        this.form[ref] = this.form[ref].replace(/\D/g, "");
    },
  }
}
</script>
